import type { ExtractionResult } from "./api";

const BOM = "﻿";

function escapeCell(v: string | number): string {
  const s = String(v);
  if (s.includes(",") || s.includes('"') || s.includes("\n")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function toCsv(result: ExtractionResult): string {
  // Wide format: x, then one column per series.
  const xs: (string | number)[] = [];
  const seen = new Set<string>();
  for (const s of result.series) {
    for (const p of s.points) {
      const k = String(p.x);
      if (!seen.has(k)) {
        seen.add(k);
        xs.push(p.x);
      }
    }
  }
  const xLabel = result.x_axis.label ?? "x";
  const headers = [xLabel, ...result.series.map((s) => s.label)];
  const rows = xs.map((x) => {
    const row: (string | number)[] = [x];
    for (const s of result.series) {
      const match = s.points.find((p) => String(p.x) === String(x));
      row.push(match ? match.y : "");
    }
    return row.map(escapeCell).join(",");
  });
  return BOM + headers.map(escapeCell).join(",") + "\n" + rows.join("\n") + "\n";
}

export function downloadFile(name: string, content: string, mime: string) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
